<template>
  <div class="col-md-2 col-12 " :class="columnClass">
    <div class="text-dark font-size-16 pt-2 pb-2">
      {{ $t(label) }}
      <span v-if="colorValue" class="font-size-12 ml-1"> ({{ colorValue }})</span>
    </div>

    <div class="row">
      <div @click="internalShowPicker = true" class="color-picker ml-2 pt-2" :style="{ backgroundColor: colorValue }"></div>
    </div>
    <div v-if="internalShowPicker && campaignId "> 
        <ColorPicker   
        type="linear"
        @changeColor="handleChange"
        @onClose="internalShowPicker = false"
        :titleConfig="titleConfig"    
        :disabledColorDeg="true"   
        :closeOnClickBody=true
        :showClose="false"
        :style="{ 
            position: 'absolute', 
            top: '-170px', 
            left: '50px', 
            zIndex: '9999',
        }"

        :pColor="pickerColor"/>
    </div>
  </div>
</template>

<script>
import ColorPicker from 'vue2-color-picker-gradient'

export default {
components: {ColorPicker},

  name: 'ColorPickerField',
  props: {
    label: String,
    colorValue: String,
    columnClass: {
      type: String,
      default: '',
    },
    showPicker: {
      type: Boolean,
      default: false,
    },
    campaignId: Number,
    titleConfig: Object,
  },
  data() {
    return {
        internalShowPicker: this.showPicker,
    };
  },

  computed: {
  pickerColor() {
    return this.colorValue
      ? this.parseColor(this.colorValue)
      : {
          hex: '#000000',
          hex8: '#000000FF',
          rgba: { r: 0, g: 0, b: 0, a: 1 },
          a: 1,
          color: 'rgba(0, 0, 0, 1)'
        } 
  }
},

  methods: {

     parseColor(value) {
      if (value.startsWith('#')) {
        const hex = value.replace('#', '')
        const r = parseInt(hex.substring(0, 2), 16)
        const g = parseInt(hex.substring(2, 4), 16)
        const b = parseInt(hex.substring(4, 6), 16)
        const a = hex.length === 8
          ? parseInt(hex.substring(6, 8), 16) / 255
          : 1

        return {
          hex: `#${hex.substring(0, 6)}`,
          hex8: hex.length === 8 ? `#${hex}` : null,
          rgba: { r, g, b, a },
          a,
          color: `rgba(${r}, ${g}, ${b}, ${a})`
        }
      }

      // RGBA fallback
      return {
        rgba: { r: 0, g: 0, b: 0, a: 1 },
        a: 1,
        color: value
      }
    },


    handleChange(newColor) {
      this.$emit('updateColor', newColor);
    },
  },
};
</script>


<style scoped>
.color-picker {
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    transition: transform 0.3s ease;
}

.color-picker:hover {
    transform: scale(1.1);
}

</style>